declare const __LATTICE_VERSION__: string;
declare const __LATTICE_RELEASE__: string;
declare const __LATTICE_REVISION__: string;

export interface ReleaseIdentity {
  version: string;
  release?: string;
  revision?: string;
}

export const LATTICE_RELEASE_INFO: Readonly<Required<ReleaseIdentity>> = Object.freeze({
  version: __LATTICE_VERSION__,
  release: __LATTICE_RELEASE__,
  revision: __LATTICE_REVISION__,
});

const placeholderRelease = new Set(["", "development", "unknown"]);

/** Compare only identifiers both builds can know. Version always remains authoritative. */
export function releaseMismatch(server: ReleaseIdentity | null | undefined): boolean {
  if (!server) return false;
  if (server.version !== LATTICE_RELEASE_INFO.version) return true;
  if (server.release && !placeholderRelease.has(server.release) && !placeholderRelease.has(LATTICE_RELEASE_INFO.release)
    && server.release !== LATTICE_RELEASE_INFO.release) return true;
  return Boolean(
    server.revision
    && !placeholderRelease.has(server.revision)
    && !placeholderRelease.has(LATTICE_RELEASE_INFO.revision)
    && server.revision !== LATTICE_RELEASE_INFO.revision,
  );
}

export function releaseIdentityLabel(identity: ReleaseIdentity): string {
  const release = identity.release && !placeholderRelease.has(identity.release) ? ` · ${identity.release}` : "";
  return `v${identity.version}${release}`;
}

export function releaseBadge(): string {
  return LATTICE_RELEASE_INFO.release === "development"
    ? `v${LATTICE_RELEASE_INFO.version} · dev`
    : `v${LATTICE_RELEASE_INFO.version} · ${LATTICE_RELEASE_INFO.release}`;
}

export function releaseDescription(): string {
  const revision = LATTICE_RELEASE_INFO.revision === "unknown"
    ? "revision unavailable"
    : `revision ${LATTICE_RELEASE_INFO.revision.slice(0, 8)}`;
  return `Lattice ${LATTICE_RELEASE_INFO.version}, ${LATTICE_RELEASE_INFO.release}, ${revision}`;
}
